import type { CreateWorkspaceInput } from '@noconflict/contracts';
import { z } from 'zod';
import { validationMessage } from '../../../shared/i18n/zod';

export type Values = CreateWorkspaceInput;

/** Same rules as the contract's `createWorkspaceInputSchema`, with messages from the catalogue. */
export const schema: z.ZodType<Values, Values> = z.object({
  name: z
    .string()
    .trim()
    .min(1, validationMessage('orgNameRequired'))
    .max(80, validationMessage('orgNameMax')),
});
